import { ui } from '@procuros/datachecks';
import isEqual from 'lodash/isEqual';

import { getCanonical, getUiDetails } from 'services/datachecks/datachecks';
import { logError } from 'services/logging/logging';
import { ProcessSpecificationDTO, TaskBaseDTO } from 'support/types';

let previousTaskResponse: Record<string, any> | null = null;

export type GetTaskUiConfigArgs = {
  data: Record<string, any>;
  actions?: NonNullable<TaskBaseDTO['actions']>;
};

export type GetTaskUiConfigResult = {
  data: Record<string, any>;
  uiConfig: Array<ui.Section>;
};

export const getTaskUiConfig = async ({
  data,
  actions,
}: GetTaskUiConfigArgs): Promise<GetTaskUiConfigResult | undefined> => {
  if (!actions || !data || Object.keys(data).length === 0) {
    throw new Error('Missing required data for processing');
  }

  try {
    const fields = actions as ProcessSpecificationDTO['fields'];
    const { canonical } = await getCanonical(fields, data);

    if (!isEqual(canonical, previousTaskResponse)) {
      previousTaskResponse = canonical;

      const uiResult = await getUiDetails({
        fields,
        data: canonical,
      });

      return {
        data: uiResult.values,
        uiConfig: uiResult.view,
      };
    }
  } catch (error) {
    logError(error);
    throw error;
  }
};

export const resetPreviousTaskResponse = () => {
  previousTaskResponse = null;
};
